//import axios from 'axios';
const state = {
  username: null,
  email: null,
 // auth_key: null,
 // password_hash: null,
  site_id: null,
  user_type: null,
  avatar: null,
 // password_reset_token: null,
  status: null,
  user_id: null,
  admin_id: null,
  firstname: null,
  lastname: null,
  token: null,

  // posts: null,
};
const getters = {
  isAuthenticated: state => !!state.username,    
  // StatePosts: state => state.posts,
  StateUsername: state => state.username,
  StateEmail: state => state.email,
 // StateAuthkey: state => state.auth_key,
 // StatePasswordhash: state => state.password_hash,
  StateSiteid: state => state.site_id,
  StateUsertype: state => state.user_type,
  StateAvatar: state => state.avatar,
 // StatePasswordresettoken: state => state.password_reset_token,
  StateStatus: state => state.status,
  StateUserid: state => state.user_id,
  StateToken: state => state.token,
  StateAdminid: state => state.admin_id,
  StateFirstname: state => state.firstname,
  StateLastname: state => state.lastname,

};
const actions = {
  async LogIn({commit}, data) {
   // await axios.post('login', Username)
  //  console.log(data);
    await commit('setUser', data.username)
   // console.log(data.username);
    await commit('setEmail', data.email)
   // console.log(data.email);
    await commit('setSiteid', data.site_id)
   // console.log(data.site_id);
    await commit('setUsertype', data.user_type)
   // console.log(data.user_type);
    await commit('setStatus', data.status)
   // console.log(data.status);
    await commit('setAvatar', data.avatar)
   // console.log(data.avatar);
    await commit('setUserid', data.user_id)
  //  console.log(data.user_id);
    await commit('setToken', data.token)
   // console.log(data.token);
   await commit('setAdminid', data.admin_id)
   await commit('setFirstname', data.firstname)
   await commit('setLastname', data.lastname)
  },
  async LogOut({commit}){
    let username = null
    let email = null
    let site_id = null
    commit('logout', username, email, site_id)
  }
};
const mutations = {
  setUser(state, username){
    state.username = username
   // console.log(state.username);
    var users = [];
    users.push({username: username});
    
    // store the data in localStorage
    localStorage.setItem("users", JSON.stringify(users));
    localStorage.setItem("isAuthenticated",true);
    //localStorage.setItem("user", "erotop");
},
setEmail(state, email){
  state.email = email
 // console.log(state.email);
 
  let users = JSON.parse(localStorage.getItem("users"));
  users.push({email: email});
  // store the data in localStorage
  localStorage.setItem("users", JSON.stringify(users));
  
  //localStorage.setItem("user", "erotop");
},
setSiteid(state, site_id){
  state.site_id = site_id
 // console.log(state.site_id);
  
  let users = JSON.parse(localStorage.getItem("users"));
  users.push({site_id: site_id});
  // store the data in localStorage
  localStorage.setItem("users", JSON.stringify(users));
  
  //localStorage.setItem("user", "erotop");
},
setUsertype(state, user_type){
  state.user_type = user_type
//  console.log(state.user_type);
  
  let users = JSON.parse(localStorage.getItem("users"));
  users.push({user_type: user_type});
  // store the data in localStorage
  localStorage.setItem("users", JSON.stringify(users));
  
  //localStorage.setItem("user", "erotop");
},
setStatus(state, status){
  state.status = status
 // console.log(state.status);
  
  let users = JSON.parse(localStorage.getItem("users"));
  users.push({status: status});
  // store the data in localStorage
  localStorage.setItem("users", JSON.stringify(users));
  
  //localStorage.setItem("user", "erotop");
},
setAvatar(state, avatar){
  state.avatar = avatar
//  console.log(state.avatar);
  
  let users = JSON.parse(localStorage.getItem("users"));
  users.push({avatar: avatar});
  // store the data in localStorage
  localStorage.setItem("users", JSON.stringify(users));
  
  //localStorage.setItem("user", "erotop");
},
setUserid(state, user_id){
  state.user_id = user_id
 // console.log(state.user_id);
  
  let users = JSON.parse(localStorage.getItem("users"));
  users.push({user_id: user_id});
  // store the data in localStorage
  localStorage.setItem("users", JSON.stringify(users));
  
  //localStorage.setItem("user", "erotop");
},
setAdminid(state, admin_id){
  state.admin_id = admin_id
 // console.log(state.user_id);
  
  let users = JSON.parse(localStorage.getItem("users"));
  users.push({admin_id: admin_id});
  // store the data in localStorage
  localStorage.setItem("users", JSON.stringify(users));
  
  //localStorage.setItem("user", "erotop");
},
setFirstname(state, firstname){
  state.firstname = firstname
 // console.log(state.user_id);
  
  let users = JSON.parse(localStorage.getItem("users"));
  users.push({firstname: firstname});
  // store the data in localStorage
  localStorage.setItem("users", JSON.stringify(users));
  
  //localStorage.setItem("user", "erotop");
},
setLastname(state, lastname){
  state.lastname = lastname
  // console.log(state.user_id);
   
   let users = JSON.parse(localStorage.getItem("users"));
   users.push({lastname: lastname});
   // store the data in localStorage
   localStorage.setItem("users", JSON.stringify(users));
   
  //localStorage.setItem("user", "erotop");
},
setToken(state, token){
  state.token = token
 // console.log(state.token);
  
  var tokens = [];
  tokens.push({token: token});
  
  // store the data in localStorage
  localStorage.setItem("tokens", JSON.stringify(tokens));
  
  //localStorage.setItem("user", "erotop");
},
// setPosts(state, posts){
//     state.posts = posts
// },
LogOut(state){
    state.username = null
    state.email = null
    state.site_id = null
    // state.posts = null
},
};
export default {
  state,
  getters,
  actions,
  mutations
};